/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentMethodDto } from './PaymentMethodDto';
import {
    PaymentMethodDtoFromJSON,
    PaymentMethodDtoFromJSONTyped,
    PaymentMethodDtoToJSON,
} from './PaymentMethodDto';

/**
 * 
 * @export
 * @interface LocationDtoV4
 */
export interface LocationDtoV4 {
    /**
     * 
     * @type {Array<PaymentMethodDto>}
     * @memberof LocationDtoV4
     */
    paymentMethods: Array<PaymentMethodDto>;
}

/**
 * Check if a given object implements the LocationDtoV4 interface.
 */
export function instanceOfLocationDtoV4(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentMethods" in value;

    return isInstance;
}

export function LocationDtoV4FromJSON(json: any): LocationDtoV4 {
    return LocationDtoV4FromJSONTyped(json, false);
}

export function LocationDtoV4FromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationDtoV4 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentMethods': ((json['paymentMethods'] as Array<any>).map(PaymentMethodDtoFromJSON)),
    };
}

export function LocationDtoV4ToJSON(value?: LocationDtoV4 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentMethods': ((value.paymentMethods as Array<any>).map(PaymentMethodDtoToJSON)),
    };
}

